import { SET_TOGGLE_SIDEBAR,SAVE_RESULT_NRW_CALCULATE,
  STORE_DATA_NRW_BY_DMA, STORE_LIST_DMA_FOR_SELECT,
  STORE_SEARCH_MONTH,STORE_SEARCH_YEAR, STORE_SEARCH_DMA } from './type';
import {toNumber} from 'lodash';
import moment from 'moment';

const initialState = {
  isToggleSideBarOpen: true,
  resultCalculate: [],
  dataNRWByDMA: {},
  listDMAForSelect: [],
  searchMonth: toNumber(moment(new Date()).format('MM')),
  searchYear: toNumber(moment(new Date()).format('yyyy')),
  searchDMA:''
}

export default function generalReducer(state = initialState, action) {
  switch (action.type) {
    case SET_TOGGLE_SIDEBAR:
      return {
        ...state,
        isToggleSideBarOpen: action.payload
      }
    case SAVE_RESULT_NRW_CALCULATE:
      return {
        ...state,
        resultCalculate: action.payload
      }
      case STORE_DATA_NRW_BY_DMA:
        return {
          ...state,
          dataNRWByDMA: action.payload
        }
        case STORE_SEARCH_MONTH:
        return {
          ...state,
          searchMonth: action.payload
        }
        case STORE_SEARCH_YEAR:
        return {
          ...state,
          searchYear: action.payload
        }
        case STORE_SEARCH_DMA:
        return {
          ...state,
          searchDMA: action.payload
        }
        case STORE_LIST_DMA_FOR_SELECT:
          return {
            ...state,
            listDMAForSelect: action.payload
          }
    default:
      return state
  }
}